import React from 'react';

const ReportsAppConfig = {
	settings: {
		layout: {
			config: {}
		}
	},
	routes: [
		{
			path: '/report/chat',
			component: React.lazy(() => import('./Chat/ChatApp'))
		},
		{
			path: '/report/agent-report',
			component: React.lazy(() => import('./agent/AgentApp'))
		},
		{
			path: '/report/surveyReport',
			component: React.lazy(() => import('./surveyReport/SurveyReport'))
		},
		{
			path: '/report/customerJourney',
			component: React.lazy(() => import('./customerJourney/SurveyReport'))
		},
		{
			path: '/report/chat-hourly',
			component: React.lazy(() => import('./ChatHourly/ChatHourly'))
		},
		{
			path: '/report/chatbot-Information-oral',
			component: React.lazy(() => import('./Chatbot Information/ChatbotInfo'))
		},
		{
			path: '/report/shell-customer',
			component: React.lazy(() => import('./Shell Customer/ShellCustomer'))
		},
		{
			path: '/report/Lemonmax-customer',
			component: React.lazy(() => import('./Lemon Max/LemonMaxCustomers'))
		},
		{
			path: '/reports/segments',
			component: React.lazy(() => import('./Segments Report/SegmentReport'))
		},
		{
			path: '/report/monthly-active-users',
			component: React.lazy(() => import('./monthlyActiveUsers/MonthlyActiveUsers'))
		},
		{
			path: '/report/complain-tickets-report',
			component: React.lazy(() => import('./tickets/ComplainTicketsReport'))
		},
		{
			path: '/report/sub-account-report',
			component: React.lazy(() => import('./Sub Account Report/SubAccReport'))
		},
		{
			path: '/reports/session-ends',
			component: React.lazy(() => import('./sessionEnds/SessionEndsApp'))
		},
	]
};

export default ReportsAppConfig;
